import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime:0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getPurchaseOrder = createAsyncThunk(
  "farmer/purchase-order",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/farmer/purchase-order", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getPurchaseOrderById = createAsyncThunk(
  "farmer/purchase-order/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/farmer/purchase-order/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortPurchaseOrder = createAsyncThunk(
  "farmer/purchase-order/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/farmer/purchase-order/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const postPurchaseOrder = createAsyncThunk(
  "farmer/purchase-order/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/farmer/purchase-order", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deletePurchaseOrder = createAsyncThunk(
  "farmer/purchase-order/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/farmer/purchase-order/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updatePurchaseOrder = createAsyncThunk(
  "farmer/purchase-order/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/farmer/purchase-order/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const purchaseOrderSlice = createSlice({
  name: "Purchase Order Store",
  initialState: initialState,
  reducers: {
    addPurchaseOrder(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortPurchaseOrder(state, action) {
      state.data.docs = action.payload;
    },
    deletePurchaseOrder(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editPurchaseOrder(state, action) {
      let x = state.data.docs.findIndex((item) => item._id === action.payload._id);
      state.data.docs[x] = action.payload;
    },
  },
  extraReducers: {
    [getPurchaseOrder.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getPurchaseOrder.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getPurchaseOrder.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getPurchaseOrderById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getPurchaseOrderById.fulfilled]: (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getPurchaseOrderById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortPurchaseOrder.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortPurchaseOrder.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortPurchaseOrder.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postPurchaseOrder.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postPurchaseOrder.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postPurchaseOrder.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deletePurchaseOrder.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deletePurchaseOrder.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deletePurchaseOrder.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updatePurchaseOrder.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updatePurchaseOrder.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updatePurchaseOrder.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const purchaseOrderActions = purchaseOrderSlice.actions;

export default purchaseOrderSlice.reducer;
